module.exports = __webpack_public_path__ + "static/media/health-and-beauty.230d34fb.png";